import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ANGULAR_HTTP_CLIENT_TOKEN } from '../angular-http-client.module';
import { Company } from '../models/company.interface';
import { environment } from '../configuration/get-environment.util';
import { catchError, Observable, throwError } from 'rxjs';
import { LogService, TOKENS } from '@trustedshops/tswp-core-common';
import { AccountService } from './account.service';
import {
  distinctUntilChanged,
  filter,
  shareReplay,
  switchMap,
} from 'rxjs/operators';

@Injectable()
export class CompanyService {
  public readonly company$: Observable<Company | undefined>;

  constructor(
    @Inject(ANGULAR_HTTP_CLIENT_TOKEN)
    private readonly httpClient: HttpClient,
    @Inject(TOKENS.LogService)
    private readonly _logService: LogService,
    private readonly accountService: AccountService
  ) {
    this.company$ = this.accountService.accountId$.pipe(
      filter((accountId): accountId is string => !!accountId),
      distinctUntilChanged(),
      switchMap((accountId) => this.getCompany(accountId)),
      shareReplay(1)
    );
  }

  getCompany(id: string) {
    return this.httpClient
      .get<Company>(
        `${environment.apis.businessHubB2B}${environment.apis.company.replace(
          '{id}',
          id
        )}`
      )
      .pipe(
        catchError((error) => {
          this._logService.error('Get Company has failed: ', error);
          return throwError(() => error);
        })
      );
  }
}
